import { axios } from '@/services/axios';

const updatePlatformUser = async ({ formData, scope }) => {
    const res = await axios.put('/PlatformUser', formData, {
        headers: {
            'X-RequestScope': scope,
        },
    });
    return res.data;
};

export default updatePlatformUser;
